import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import useGetData from 'hooks/useGetData'
import CardBlockerList from 'components/CardBlockerList'
import Loader from './Loader'
import useSaga from 'hooks/useSaga'
import { CHANNEL_DATA } from 'CHANNEL_DATA'
import { takeEvery } from 'redux-saga/effects'
import ChannelsContext from 'contexts/ChannelsContext'
import _ from 'lodash'

const makeChannelData = (onChannelData) => {
  return function * (action) {
    const { channel, actionName, elementName, data } = action.payload

    yield onChannelData({ channel, actionName, elementName, data })
  }
}

function * channelData (onChannelData) {
  const channelData = makeChannelData(onChannelData)

  yield takeEvery(CHANNEL_DATA, channelData)
}

const CardBlockers: React.FC<{
  blockerId?: number;
  boardId?: number;
}> = ({
  blockerId,
  boardId,
}) => {
  const {
    addChannel,
    removeChannel
  } = useContext(ChannelsContext)

  const args = useMemo(() => ({
    blockerId,
    boardIds: boardId ? [boardId] : undefined,
  }), [blockerId, boardId])
  const {
    data,
  }: {
    data: any,
  } = useGetData(blockerId ? 'BlockerImpact' : 'CardBlockersImpact', args)

  const [cardBlockers, setCardBlockers] = useState<any[]>([])

  const cardIds = useMemo(() =>
    Array.from(new Set<number>(cardBlockers.map(cardBlocker => cardBlocker.cardId)))
  , [cardBlockers])

  useEffect(() => {
    for (const cardId of cardIds) {
      addChannel(`card-${cardId}`, () => {})
    }

    return () => {
      for (const cardId of cardIds) {
        removeChannel(`card-${cardId}`)
      }
    }
  }, [cardIds])

  useEffect(() => {
    if (data) {
      if (data.CardsImpact) {
        setCardBlockers(data.CardsImpact.map(CardBlocker => ({
          id: CardBlocker.Id,
          cardId: CardBlocker.CardId,
          name: CardBlocker.Name,
          description: CardBlocker.Description && JSON.parse(CardBlocker.Description),
          creationDate: CardBlocker.CreationDate,
          createdBy: CardBlocker.CreatedBy,
          reason: CardBlocker.Reason,
          userId: CardBlocker.UserId,
        })))
      } else {
        setCardBlockers([])
      }
    }
  }, [data])

  const handleChannelDataRef = useRef<(arg: any) => void>()

  useEffect(() => {
    handleChannelDataRef.current = ({ actionName, elementName, data }) => {
      if (actionName + elementName === 'RemoveBlockerFromCard/Primitive/Int32') {
        setCardBlockers(cardBlockers =>
          cardBlockers.filter(cardBlocker => cardBlocker.id !== data.Value)  
        )
      } else if (actionName + elementName === 'RemoveBlockerFromCard/Data/CollectionIds') {
        setCardBlockers(cardBlockers =>
          cardBlockers.filter(cardBlocker => !data.Values.includes(cardBlocker.id))  
        )
      }
    }
  }, [boardId])

  const handleChannelData = useCallback(
    (arg) => {
      handleChannelDataRef.current?.(arg)
    },
    []
  )

  useSaga(channelData, handleChannelData)

  return data ? (
    <CardBlockerList
      cardBlockers={cardBlockers}
    />
  ) : <Loader center />
}

export default CardBlockers
